// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ku-1";
export var messageSideRight = "_ku-2";
export var orderLookupBubbleContainer = "_ku-0";
export var submitButton = "_ku-3";